// extracted by mini-css-extract-plugin
module.exports = {"root":"FooterAbout_root__1LJ8u","title":"FooterAbout_title__3lUIB","text":"FooterAbout_text__I0Cgc"};